<template>
    <div>
        <div class="lightbox-gallery-trigger" @click="show = true">
            <slot></slot>
        </div>

        <vue-easy-lightbox
        :visible="show"
        :imgs="images"
        :index="index"
        @hide="handleHide"
        >
        </vue-easy-lightbox>
    </div>
</template>
<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
    components : {
        VueEasyLightbox
    },

    props : {
        images : {
            Type : Array,
            required : true
        },
        initialIndex : {
            Type : [Number|null],
            required : false,
            default : 0
        }
    },

    data(){
        return {
          show: false,
          index : 0,
        }
    },


    methods : {
        handleHide(){
            this.show = false
        }
    },

    mounted(){
        this.index = this.initialIndex
    }
}
</script>